import { Container } from '~/components/Container/Container';
import { useAuthentication } from '~/hooks/useAuthentication';
import { CloseIcon } from '~/components/Icon/CloseIcon';
import { MenuIcon } from '~/components/Icon/MenuIcon';
import { Fragment, useState } from 'react';
import logo from '~/assets/ssf-logga.svg';
import styles from './Header.module.css';
import { Link } from 'react-router';
import classNames from 'classnames';

export function Header() {
  const { isAuthenticated, logout } = useAuthentication();
  const [isOpen, setIsOpen] = useState(false);

  async function handleLogout() {
    setIsOpen(p => !p);
    await logout();
  }

  return (
    <header className={styles.header}>
      <Container>
        <div className={styles.inner}>
          <Link to="/" className={styles.logotype}>
            <img src={logo} alt="Svenska Styrkelyftförbundet" />
          </Link>

          <button
            aria-label={isOpen ? 'Stäng meny' : 'Öppna meny'}
            onClick={() => setIsOpen(p => !p)}
            className={styles.hamburger}
          >
            {isOpen ? <CloseIcon /> : <MenuIcon />}
          </button>

          <nav className={classNames(styles.nav, { [styles.open]: isOpen })}>
            <Container>
              <ul>
                <li>
                  <Link to="/rankings" onClick={() => setIsOpen(p => !p)}>
                    Ranking
                  </Link>
                </li>
                <li>
                  <Link to="/lifters" onClick={() => setIsOpen(p => !p)}>
                    Lyftare
                  </Link>
                </li>
                <li>
                  <Link to="/competitions" onClick={() => setIsOpen(p => !p)}>
                    Tävlingar
                  </Link>
                </li>
                <li>
                  <Link to="/records" onClick={() => setIsOpen(p => !p)}>
                    Rekord
                  </Link>
                </li>

                <li>
                  <Link to="/clubs" onClick={() => setIsOpen(p => !p)}>
                    Föreningar
                  </Link>
                </li>
                <li>
                  <Link to="/districts" onClick={() => setIsOpen(p => !p)}>
                    Distrikt
                  </Link>
                </li>
                <li>
                  <Link to="/referees" onClick={() => setIsOpen(p => !p)}>
                    Domare
                  </Link>
                </li>
                <li>
                  <Link to="/series/divisions" onClick={() => setIsOpen(p => !p)}>
                    Serier
                  </Link>
                </li>
              </ul>

              <ul>
                {isAuthenticated ? (
                  <Fragment>
                    <li>
                      <Link to="/admin" onClick={() => setIsOpen(p => !p)}>
                        Admin
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={handleLogout}>
                        Logga ut
                      </Link>
                    </li>
                  </Fragment>
                ) : (
                  <Fragment>
                    <li>
                      <Link to="auth/sign-up" onClick={() => setIsOpen(p => !p)}>
                        Skapa konto
                      </Link>
                    </li>
                    <li>
                      <Link to="/auth/sign-in" onClick={() => setIsOpen(p => !p)}>
                        Logga in
                      </Link>
                    </li>
                  </Fragment>
                )}
              </ul>
            </Container>
          </nav>
        </div>
      </Container>
    </header>
  );
}
